import { useEffect, useState } from 'react';
import {
  HeaderMobile,
  HeaderDesktop,
  TerminationAlert,
} from '~/Header'
import { useNavigation } from "@/processes/Router";
import { CreateSubAccountModal } from '@/features/shared/Accounts';

export type HeaderProps = {
  className?: string;
  withAddonsCenter?: boolean;
  withSubAccounts?: boolean;
  withAddonsLeft?: boolean;
  withAddonsRight?: boolean;
  withTopBanner?: boolean;
}

const SCROLL_THRESHOLD_PX = 60;

const Header = (props: HeaderProps) => {
  const { withTopBanner = false } = props;
  const { isDashboard  } = useNavigation();
  const [isFixed, setIsFixed] = useState(withTopBanner);
  useEffect(() => {
    setIsFixed(withTopBanner);
  }, [withTopBanner]);

  useEffect(() => {
    if (!withTopBanner) return;
    const handleScroll = () => {
      setIsFixed(window.scrollY >= SCROLL_THRESHOLD_PX);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [withTopBanner]);

  return (
    <>
      {/* reserve space when fixed */}
      {withTopBanner ? (
        isFixed && <div className="h-[140px] lg:h-[114px]" aria-hidden="true"/>
      ) : (
        <div className="h-[140px] lg:h-[114px]" aria-hidden="true"/>
      )}

      <header className={`max-w-[1536px] w-full mx-auto py-4 px-4 mobile-ls:py-4 sm:py-6 bg-[#000018]/[0.95] ${isFixed || !withTopBanner ? "fixed left-0 right-0 top-0 z-50" : "relative"}`}>
        <HeaderMobile className={`${isDashboard ? "lg:hidden" : "md:hidden"}`} {...props}/>
        <HeaderDesktop className={`${isDashboard ? "lg:flex" : "md:flex"} hidden items-center justify-between`} {...props}/>
        <CreateSubAccountModal />
        <TerminationAlert />
      </header>
    </>
  )
}

export default Header;
